import { Component, Input, OnInit } from '@angular/core';
import { HeadersFacade } from '../../../domain/facades/facades';
import { CheckOutFacades } from 'imakeapp-checkout';

@Component({
  selector: 'lib-branches-modal-cell',
  templateUrl: './branches-modal-cell.component.html',
  styleUrls: ['./branches-modal-cell.component.css']
})
export class BranchesModalCellComponent implements OnInit
{


  @Input() vendor_branches: any;

  active_branch: any;




  constructor(
    private header_facades: HeadersFacade,private checkOutFacades:CheckOutFacades
  ) { }

  ngOnInit(): void
  {
    this.listen_to_display_status();
  }



  listen_to_display_status()
  {


    this.header_facades.active_branch_selector$.subscribe(
      (state)=>{
        this.active_branch = state;
      }
    );


  }


  branch_selected_handler(branch: any)
  {

    this.header_facades.set_active_branch(branch);
    this.header_facades.show_branches_modal(false);
    this.checkOutFacades.selectBranchForCheckout(branch.branchId!)

  }



}
